export const home = {
  "hero.title": "AllChinaBuy Spreadsheet 2026",
  "hero.subtitle": "104+ organiserede fund med direkte købslinks — Slut med endeløs søgning",
  "hero.description": "Gennemse organiserede produktkategorier, verificerede sælgeroplysninger og købslinks med ét klik. Fra sneakers til hættetrøjer — alt er sorteret og klar.",
  "hero.cta.primary": "AllChinaBuy Spreadsheet",
  "hero.cta.secondary": "Køb Det Nu",
  "trust.line": "Uafhængig Ressource • Regelmæssigt Opdateret • Multisproget • Bygget til Internationale Købere",
  "search.title": "Find Det, Du Leder Efter",
  "search.placeholder": "Søg sko, hættetrøjer, forsendelse, QC, sælgere...",
  "search.cta": "Søg i Spreadsheet",
  "categories.title": "Populære Kategorier",
  "categories.cta": "Se Alle Kategorier",
  "spreadsheet.title": "AllChinaBuy Spreadsheet, Organiseret for Nemmere Research",
  "spreadsheet.description": "Udforsk kategorier, sammenlign produkter, gennemgå nyttige oplysninger og få adgang til detaljerede købsguider fra én organiseret ressource.",
  "spreadsheet.cta": "Udforsk Spreadsheet",
  "howitworks.title": "Sådan Fungerer Det",
  "howitworks.step1": "Find en kategori",
  "howitworks.step2": "Sammenlign produkter",
  "howitworks.step3": "Tjek QC- og sælgeroplysninger",
  "howitworks.step4": "Research forsendelse",
  "howitworks.step5": "Fortsæt til dit foretrukne websted",
  "trust.title": "Research Før Du Køber",
  "trust.description": "Dækker produktresearch, QC, sælgere, forsendelse, lager, rabatter og sikkerhed.",
  "review.title": "AllChinaBuy Anmeldelse",
  "review.shipping": "AllChinaBuy Forsendelsesomkostninger",
  "review.warehouse": "AllChinaBuy Lager",
  "review.legit": "Er AllChinaBuy Legitim",
  "review.coupon": "AllChinaBuy Kupon",
  "review.discount": "AllChinaBuy Rabatkode",
  "safety.title": "Køb Klogere. Bliv Sikrere.",
  "safety.description": "Lær hvordan du verificerer links, sælgere, QC-oplysninger, betalinger og forsendelsesoplysninger.",
  "articles.title": "Seneste Købsguider",
  "articles.cta": "Læs Alle Guider",
  "final.title": "Klar til at Udforske AllChinaBuy?",
  "final.description": "Start med AllChinaBuy Spreadsheet og opdag nyttige ressourcer for bedre informerede købsbeslutninger.",
  "final.cta": "Udforsk AllChinaBuy Spreadsheet",
  "nav.home": "Hjem",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Kategorier",
  "nav.shoppingGuide": "Købsguide",
  "nav.guides": "Guider",
  "nav.reviews": "Anmeldelser",
  "nav.shipping": "Forsendelse",
  "nav.qc": "QC",
  "nav.safety": "Sikkerhed",
  "nav.blog": "Blog",
  "footer.disclaimer": "Dette er et uafhængigt informativt websted og ikke det officielle AllChinaBuy-websted. Verificer altid oplysninger, før du foretager et køb.",
  "footer.rights": "Alle rettigheder forbeholdes.",
  "lang.en": "EN",
  "lang.fr": "FR",
  "lang.de": "DE",
  "lang.da": "DA",
  "dropdown.title": "Gennemse Kategorier",
  "products.title": "Trendende Produkter",
  "products.description": "Gennemse produkter fra AllChinaBuy Spreadsheet og klik for at købe",
  "products.buyNow": "Kob Nu",
  "products.viewAll": "Se Alle",
  "seo.h1": "AllChinaBuy Spreadsheet — Find Produkter, Links og Købsguider"
};

export const article = {
  "article.title": "Komplet Guide til AllChinaBuy Spreadsheet",
  "article.subtitle": "Alt hvad du behøver at vide om brugen af AllChinaBuy spreadsheet til klogere shopping",
  "article.intro": "AllChinaBuy spreadsheet er blevet et væsentligt værktøj for internationale købere, der ønsker at organisere deres produktresearch, sammenligne fund på tværs af kategorier og træffe velinformerede købsbeslutninger. Denne omfattende guide dækker alt fra grundlæggende navigation til avancerede filtreringsteknikker.",
  "article.toc": "Indholdsfortegnelse",
  "article.whatIs": "Hvad er AllChinaBuy Spreadsheet?",
  "article.whatIsText": "En AllChinaBuy spreadsheet er en kurateret samling af produktlinks, sælgeroplysninger, kvalitetskontrolfotos (QC) og prisdata organiseret i kategorier. Den fungerer som et research-hub, hvor købere kan gennemse verificerede fund, før de foretager køb.",
  "article.howToUse": "Sådan Bruger Du AllChinaBuy Spreadsheet",
  "article.howToUseText": "Start med at vælge din foretrukne kategori fra dropdown-menuen. Hver kategori indeholder organiserede lister med produktnavne, direkte links, prisintervaller og tilgængelige QC-oplysninger. Brug søgefunktionen til hurtigt at finde specifikke varer eller sælgere.",
  "article.categories": "Populære Kategorier Forklaret",
  "article.categoriesText": "Spreadsheetet dækker alle vigtige indkøbskategorier: Sko omfatter sneakers, støvler og designerfodtøj; Hættetrøjer inkluderer mærke- og streetwear-muligheder; T-shirts tilbyder grafiske og simple valg; Jakker dækker overtøj.",
  "article.qc": "Forstå QC-Oplysninger",
  "article.qcText": "Kvalitetskontrolfotos (QC) er essentielle for at verificere produktkvalitet før forsendelse. Spreadsheetet inkluderer ofte links til QC-album eller noter om hvilke sælgere der leverer detaljerede inspektionsfotos.",
  "article.shipping": "Forsendelsesresearch Tips",
  "article.shippingText": "Før du bestiller, research forsendelsesmetoder og estimerede omkostninger til dit land. Forskellige agenter tilbyder varierende priser, leveringstider og pakkekonsolideringsmuligheder.",
  "article.safety": "Sikkerhed og Verifikation",
  "article.safetyText": "Verificer altid links før du klikker, især når du tilgår spreadsheets fra tredjepartskilder. Bogmærk officielle eller betroede spreadsheet-spejle for at undgå phishing-forsøg.",
  "article.conclusion": "Konklusion",
  "article.conclusionText": "AllChinaBuy spreadsheet forbliver en af de mest værdifulde ressourcer til organiseret produktresearch i international shopping. Ved at mestre navigationen, forstå kategoristrukturerne og anvende sikkerhedspraksis kan du forbedre din shoppingoplevelse betydeligt.",
  "article.faq": "Ofte Stillede Spørgsmål",
  "article.faq1": "Hvad er AllChinaBuy Spreadsheet?",
  "article.faq1Answer": "AllChinaBuy Spreadsheet er en organiseret samling af produktlinks, sælgeroplysninger og købsressourcer for internationale købere.",
  "article.faq2": "Er AllChinaBuy legitim og sikker?",
  "article.faq2Answer": "AllChinaBuy er en velkendt indkøbsagent. Recherchér sælgere grundigt og verificer oplysninger før køb.",
  "article.faq3": "Hvordan finder jeg produkter i spreadsheet?",
  "article.faq3Answer": "Brug kategori-dropdown eller søgefunktion til at gennemse produkter organiseret efter type.",
  "article.faq4": "Hvilke forsendelsesmuligheder er tilgængelige?",
  "article.faq4Answer": "Forsendelsesmuligheder varierer efter agent og destination. Almindelige metoder inkluderer EMS, DHL, FedEx og forskellige posttjenester.",
  "article.cta": "Tilbage til AllChinaBuy Spreadsheet Startside",
  "article.metaTitle": "Komplet Guide til AllChinaBuy Spreadsheet | Tips & Ressourcer 2026",
  "article.metaDescription": "Lær at bruge AllChinaBuy spreadsheet effektivt. Opdag produktkategorier, QC-tips, forsendelsesresearch og sikkerhedsretningslinjer."
};

export default { ...home, ...article };